import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketMetaField } from "../../../../../../administration/ticket_creation/types/field_configs/Meta";

type Props = {
  field: Extract<TicketMetaField, { type: "string" }>;
  name: string;
};

export const StringInput = observer((props: Props) => {
  return (
    <Form.Item
      name={props.name}
      label={props.field.label}
      help={props.field.description}
    >
      <Input />
    </Form.Item>
  );
});
